// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setRiskProfile = createAction('[Custom PDF Report Modal] Set Risk Profile', props());
